import { useEffect } from 'react';

const DEFAULT_TITLE =
  'Oneshoo, an independent studio';
const DEFAULT_DESCRIPTION =
  'Oneshoo Ltd is an independent studio making games, AI-driven YouTube channels and things for the internet.';

function setMetaDescription(content) {
  let tag = document.querySelector('meta[name="description"]');
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', 'description');
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title || DEFAULT_TITLE;
    setMetaDescription(description || DEFAULT_DESCRIPTION);
  }, [title, description]);
}

export default usePageMeta;
